// Errors can carry a translation key for the user and the input field they're about (the API client's errors do);
// anything else, e.g. a failed network request, gets the generic message.
export const getErrorMessageKey = (error: unknown): string =>
    error instanceof Error && 'messageKey' in error && typeof error.messageKey === 'string'
        ? error.messageKey
        : 'errors.failed';

export const getErrorField = (error: unknown): string | null =>
    error instanceof Error && 'field' in error && typeof error.field === 'string' ? error.field : null;
